import React, { Component } from "react";
import styled from "styled-components";
import {
  Card,
  H3,
  ButtonGroup,
  Button,
  NonIdealState
} from "@blueprintjs/core";

import { withFirebase } from "../components/Firebase";
import { withAuthentication } from "../components/Session";
import GalleryCard from "../components/GalleryCard";
import GalleryAdd from "../components/GalleryAdd";

const GalleryContainer = styled.div`
  flex: 1;
  overflow: scroll;
`;

const Row = styled.div`
  display: flex;
  padding: 1rem;
  flex-wrap: wrap;
`;

const Col = styled.div`
  padding: 1rem;
  & > a:hover {
    text-decoration: none;
  }
`;

interface Props {
  firebase: any;
}

class Gallery extends Component<Props> {
  state = {
    scripts: [],
    loading: true
  };
  componentDidMount() {
    this.props.firebase.db
      .collection("scripts")
      .get()
      .then(querySnapshot => {
        let scripts = [];
        querySnapshot.forEach(doc => {
          // doc.data() is never undefined for query doc snapshots
          scripts.push({
            id: doc.id,
            ...doc.data()
          });
        });
        this.setState({ scripts, loading: false });
      })
      .catch(error => {
        console.log("Error getting documents: ", error);
      });
  }

  render() {
    return (
      <GalleryContainer>
        {this.state.loading === false && (
          <Row>
            <Col>
              <GalleryAdd link="/scripts/new" />
            </Col>
            {this.state.scripts.map(script => (
              <Col key={script.id}>
                <GalleryCard design={script} link={`/scripts/${script.id}`} />
              </Col>
            ))}
          </Row>
        )}
      </GalleryContainer>
    );
  }
}

export default withAuthentication(withFirebase(Gallery));
